import React, { useEffect } from "react";
import Alert from "components/Alert";
import useFeatureFlag from "hooks/useFeatureFlag";
import { useTranslation } from "react-i18next";
import GraphicObject from "../components/GraphicObject";
import { BPEStore } from "../ProductEditorStore";
import { observer } from "mobx-react-lite";
import clsx from "clsx";

const ProductGraphic = () => {
  const { isFeatureVisible } = useFeatureFlag();
  const { t } = useTranslation();

  const graphicData = BPEStore.graphicData;

  useEffect(() => {
    BPEStore.loadPatterns();
  }, []);

  if (!isFeatureVisible("product_graphic")) return <></>;

  const hasGraphics = (graphicData?.layers?.length ?? 0) > 0;
  let alertMessage: string | null = null;

  if (!hasGraphics) {
    const isAnyGroupSelected = BPEStore.data.groups.some(
      (item) => item.generate_graphic
    );

    const isAnyGroupNotEmpty = BPEStore.data.groups.some(
      (item) => item.epds?.filter((e) => e.epd?.id != "")?.length > 0
    );

    const totallyEmpty = !isAnyGroupSelected && !isAnyGroupNotEmpty;
    const factorError = isAnyGroupNotEmpty && isAnyGroupSelected;

    if (totallyEmpty) {
      alertMessage = t("productEditor.noGraphicAlert");
    } else if (factorError) {
      alertMessage = t("productEditor.noFactorsAlert");
    } else {
      alertMessage = t("productEditor.graphicInfo");
    }
  }

  React.useEffect(() => {
    // clear diagram when it has an error
    alertMessage && BPEStore.setDiagramsToUpload([]);
  }, [alertMessage]);

  return (
    <div className="py-6 border-b border-gray-200 xl:border-b-0 xl:border-t">
      <div className="text-base font-semibold mb-3 flex items-center">
        {t("productEditor.prodcutGraphic")}
      </div>

      <div className="bg-gray-50 rounded-md flex flex-col items-center justify-between py-2 relative">
        <div className="flex flex-col items-center justify-center">
          {hasGraphics && (
            <GraphicObject
              info={graphicData}
              size={200}
              patternImages={BPEStore.patternImages}
            />
          )}
          {alertMessage && (
            <Alert
              type="info"
              description={alertMessage}
              className={clsx("bg-transparent border-none py-0 px-4", {
                "mt-3": hasGraphics,
              })}
              iconClassName="flex items-center"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(ProductGraphic);
